import { Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';
import { CourseManagementService } from '@edtech-ui/core/services/course-management/course-management.service';

@Component({
	selector: 'app-course-creation-objective',
	standalone: true,
	imports: [MatIconModule, ReactiveFormsModule],
	templateUrl: './course-creation-objective.component.html',
	styleUrl: './course-creation-objective.component.scss'
})
export class CourseCreationObjectiveComponent {

	createCourseForm!: FormGroup;
	classroomId: any;

	constructor(
		private router: Router,
		private courseService: CourseManagementService,
		private route: ActivatedRoute
	) {
		this.createCourseForm = new FormGroup({
			course_objectives: new FormControl('', [Validators.required]),

		});
	}
	ngOnInit(): void {
		this.route.parent?.paramMap.subscribe(params => {
			this.classroomId = params.get('classroomId') ?? '';
		});

		const existing = this.courseService.getPayload();
		if (existing.course_objectives?.length) {
			this.createCourseForm.patchValue({
				course_objectives: existing.course_objectives.join('\n')
			});
		}

	this.createCourseForm.valueChanges.subscribe(val => {
	const objectivesArray = val.course_objectives
		.split('\n')
		.map((obj: string) => obj.trim())
		.filter((obj: string) => obj.length > 0);

	this.courseService.updatePayload({ course_objectives: objectivesArray });
});

	}



	goToPrePage() {
		this.router.navigate(['/teacher-dashboard', this.classroomId, 'manual-course-creation', 'course-creation-form']);
	}
	goToNextPage() {
		if (this.createCourseForm.invalid) return;
		this.router.navigate(['/teacher-dashboard', this.classroomId, 'manual-course-creation', 'add-units']);
	}

}
